import useAppStore from "@/context/store";
import { useMemo } from "react";

export function useGlobalNotice() {
  const { globalNotice = {} } = useAppStore(({ globalNotice }) => ({
    globalNotice,
  }));

  const hasNotice = useMemo(() => {
    return globalNotice?.visible && globalNotice.content;
  }, [globalNotice]);

  return {
    globalNotice,
    hasNotice,
  };
}
